
export const getBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
export const base64ToFormData = (base64Data, filename = "shot.png") => {
  // 1. 分离 MIME 类型和纯 Base64 数据
  const [header, base64] = base64Data.split(",");
  const mimeType = (header.match(/:(.*?);/) || [])[1] || "application/octet-stream";

  // 2. 解码 Base64 为二进制
  const binaryStr = atob(base64);
  const byteArray = new Uint8Array(binaryStr.length);

  for (let i = 0; i < binaryStr.length; i++) {
    byteArray[i] = binaryStr.charCodeAt(i);
  }

  // 3. 创建 Blob 并添加到 FormData
  const blob = new Blob([byteArray], { type: mimeType });
  const formData = new FormData();
  formData.append("file", blob, filename);

  return formData;
};
